export default {
  // design version 1
  yellow: '#FFEF22',
  steelGray: '#C4CFD6',
  steelGrayDark: '#494b6a',
  secureGreen: '#3B8039', 
  black: '#4A4A4A',
  gray: '#929292',
  lighterGray: '#979797',
  lightestGray: '#FDFDFD',

  // design version 2
  green: '#50D6A9'
};



// WEBPACK FOOTER //
// ./src/utils/colors.js